import PropTypes from 'prop-types';

export default PropTypes.shape({
  taxYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  countryTaxType: PropTypes.string.isRequired,
  entryType: PropTypes.string.isRequired,
  entryActivity: PropTypes.string.isRequired,
  bookType: PropTypes.string.isRequired,
  account: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  netAmount: PropTypes.number.isRequired,
  grossAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([''])]),
  fromAccount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  glAccountOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  comment: PropTypes.string,
  topsideFlag: PropTypes.bool,
});
